"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../services");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../../utils/constants");
var _SelectInput = _interopRequireDefault(require("./SelectInput"));
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _uiSelectors = require("../../../store/ui/uiSelectors");
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
var _useAppSelector = require("../../../hooks/useAppSelector");
var _useRecommendationCosts = require("../../../hooks/recommendation/useRecommendationCosts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SmallImageContainer = _styledComponents.default.div`
  width: 40px;
`;
const CenteringWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContainerWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const StyledPrice = _styledComponents.default.span`
  color: #0d0d0d;
  text-decoration: line-through;
  text-align: center;
`;
const StyledTitle = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  height: ${props => props.isSmall && '70px'};
`;
const StyledImage = (0, _styledComponents.default)(_r10SourceLibrary.Image)`
  max-height: ${props => props.maxHeight};
`;
const CustomParagraph = _ref => {
  let {
    weight,
    size,
    index,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: size,
    weight: weight,
    justify: "center",
    dataSelectorPrefix: "paragraph",
    dataAttributes: {
      productTitle: 'paragraph',
      'data-test-id': `product-id-${index}`
    }
  }, children);
};
const CustomImage = _ref2 => {
  let {
    height,
    srcUrl,
    index,
    maxHeight
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(StyledImage, {
    alt: "",
    maxHeight: maxHeight,
    sm: {
      src: srcUrl,
      height
    },
    width: "full",
    dataAttributes: {
      'data-test-id': `product-img-${index}`
    }
  });
};
const HandsetCardContent = _ref3 => {
  var _selectedVariant$medi, _getCosts;
  let {
    setSelectedProduct,
    selectOptions,
    selectedProduct,
    onSelect,
    index = null
  } = _ref3;
  const {
    paymentOption,
    productId,
    productName,
    selectedVariant
  } = selectedProduct;
  const isBottomDiscount = (0, _useLocalTheme.default)('pages.COMPARISON.isBottomDiscount', false);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const termTranslationText = paymentOption !== null && paymentOption !== void 0 && paymentOption.term.unit ? _services.locale.localeString(`Comparison.${paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.term.unit}`) : '';
  const paymentTermText = (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.priceType) === _constants.PRICE_TYPES.RECURRING ? termTranslationText : '';
  const showAllComparisonProductActions = (0, _useConfig.default)('uiSettings.showAllComparisonProductActions', true);
  const priceTopMargin = showAllComparisonProductActions ? 0 : 8;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const showPricePrefix = (0, _useLocalTheme.default)(`pages[${currentPage}].showPricePrefix`, true);
  const pricePrefix = showPricePrefix ? _services.locale.localeString(`Comparison.From`) : '';
  const images = selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$medi = selectedVariant.media) === null || _selectedVariant$medi === void 0 ? void 0 : _selectedVariant$medi.filter(img => img.id.includes(selectedVariant.variantId) && img.name !== 'description-image');
  const costsDiscount = (_getCosts = (0, _useRecommendationCosts.getCosts)(selectedVariant)) === null || _getCosts === void 0 ? void 0 : _getCosts.discount;
  const discountPrices = costsDiscount ? (0, _useRecommendationCosts.calcPriceDiscount)(costsDiscount) : {
    discountPercentage: 0
  };
  const {
    discountPriceValue,
    discountPercentage
  } = discountPrices;
  const priceValue = discountPriceValue > 0 ? discountPriceValue : paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice;
  const hideDiscount = (0, _useConfig.default)('hideDiscount', false);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const hideDiscountPercentage = hideDiscount && discountPercentage < minimumDiscount;
  const handsetPrice = priceValue ? _services.locale.formatPrice(priceValue) : paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.price;
  const PriceWrapper = isBottomDiscount ? _react.Fragment : _r10SourceLibrary.Spacing;
  return /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    id: "handset-card"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    isSmall: breakpoints.sm
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, showAllComparisonProductActions ? /*#__PURE__*/_react.default.createElement(_SelectInput.default, {
    productId: productId,
    selectOptions: selectOptions,
    onChangeHandle: setSelectedProduct
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(CustomParagraph, {
    size: 2,
    weight: 3,
    index: index
  }, productName)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(CustomParagraph, {
    size: 1,
    weight: 2,
    index: index
  }, productName)))))), (images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(CustomImage, {
    srcUrl: images[0].url,
    height: showAllComparisonProductActions ? '104px' : '150px',
    index: index
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(SmallImageContainer, null, /*#__PURE__*/_react.default.createElement(CustomImage, {
    srcUrl: images[0].url,
    maxHeight: '70px',
    index: index
  })))))), showAllComparisonProductActions && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    appearance: "secondary",
    text: _services.locale.localeString('Comparison.ButtonText'),
    width: "full",
    onClick: () => {
      onSelect(productId);
    }
  }))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, !isBottomDiscount && (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#0D0D0D',
      textDecoration: 'line-through'
    }
  }, `${paymentOption.previousPrice} ${paymentTermText}`))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(PriceWrapper, {
    spacingLevel: {
      bottom: 3,
      top: priceTopMargin
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3,
    noMargin: true,
    justify: "center",
    dataAttributes: {
      'data-test-id': `product-price-${index}`
    }
  }, `${pricePrefix} ${handsetPrice} ${paymentTermText}`), isBottomDiscount && (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && _services.locale.formatPrice(priceValue) !== (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && !hideDiscountPercentage && /*#__PURE__*/_react.default.createElement(StyledPrice, null, `${paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice} ${paymentTermText}`))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 2,
    noMargin: true,
    dataAttributes: {
      'data-test-id': `product-price-${index}`
    }
  }, `${pricePrefix} ${_services.locale.formatPrice(priceValue)} ${paymentTermText}`), isBottomDiscount && (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && _services.locale.formatPrice(priceValue) !== (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && !hideDiscountPercentage && /*#__PURE__*/_react.default.createElement(StyledPrice, null, `${paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice} ${paymentTermText}`))))))));
};
var _default = HandsetCardContent;
exports.default = _default;